
import { Component, Vue, Prop } from "nuxt-property-decorator";
@Component
export default class BeneAzienda extends Vue {
  @Prop() title!: string;
  @Prop() fields!: any;
}
